import script from "./ActAcc.vue?vue&type=script&setup=true&lang=js"
export * from "./ActAcc.vue?vue&type=script&setup=true&lang=js"

import "./ActAcc.vue?vue&type=style&index=0&id=12bc2804&lang=scss"

const __exports__ = script;

export default __exports__